<template>
  <v-content>
    <v-container my-10>
      <v-layout align-center justify-center>
        <v-progress-circular
          :size="55"
          :width="4"
          indeterminate
          color="primary"
          class="mt-12"
          v-if="loading"
        ></v-progress-circular>
        <v-card v-if="!loading" width="650px">
          <v-card-title>
            <span class="headline">{{
              $t("builder.documents.details.preview")
            }}</span>
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-btn
                text
                color="primary"
                @click="edit()"
                v-if="editedItem.is_editable"
                ><v-icon small data-cy="documentDetailsEditBtn" class="mx-2"
                  >mdi-pencil</v-icon
                >{{ $t("builder.documents.details.edit") }}</v-btn
              >
              <v-btn
                text
                color="red"
                @click="deleteFn()"
                v-if="editedItem.is_removable"
              >
                <v-icon small data-cy="documentDetailsDeletelBtn" class="mx-2"
                  >mdi-delete</v-icon
                >{{ $t("builder.documents.details.delete") }}</v-btn
              >
            </v-card-actions>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0" pa-1 ma-1>
                    <v-card-title class="subtitle-1">{{
                      $t("builder.documents.details.title")
                    }}</v-card-title>
                    <v-card-subtitle> {{ editedItem.title }}</v-card-subtitle>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0" pa-1 ma-1>
                    <v-card-title class="subtitle-1">{{
                      $t("builder.documents.details.category")
                    }}</v-card-title>
                    <v-card-subtitle>
                      <v-chip
                        v-bind:key="category"
                        v-for="category in editedItem.categories"
                        class="mx-1"
                      >
                        <span>{{ category }}</span>
                      </v-chip></v-card-subtitle
                    >
                  </v-card>
                </v-col>

                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0" pa-1 ma-1>
                    <v-card-title class="subtitle-1">{{
                      $t("builder.documents.details.visibility")
                    }}</v-card-title>
                    <v-card-subtitle>
                      {{ editedItem.crm_group.name }}</v-card-subtitle
                    >
                  </v-card>
                </v-col>

                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0" pa-1 ma-1>
                    <v-card-title class="subtitle-1">
                      {{
                        $t("builder.documents.details.resources")
                      }}:</v-card-title
                    >
                    <v-card-subtitle
                      v-if="editedItem.file_resources.length !== 0"
                    >
                      <v-list
                        subheader
                        v-for="(attachment, index) in editedItem.file_resources"
                        :key="index"
                      >
                        <v-list-item class="pl-0">
                          <v-list-item-content>
                            <v-list-item-title>
                              <v-icon class="mr-2">{{
                                getAttachmentIcon(
                                  attachment.internalType,
                                  attachment.type
                                )
                              }}</v-icon>
                              <a
                                :href="attachment.link || attachment.file"
                                target="_blank"
                              >
                                <span v-if="attachment.type !== 'link'">
                                  {{ attachment.title }}
                                </span>

                                <span v-if="attachment.type === 'link'">
                                  {{ attachment.link }}
                                </span>
                              </a>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <v-chip
                                class="mr-1 mt-1"
                                v-for="(
                                  language, index
                                ) in attachment.languages"
                                :key="index"
                              >
                                {{ getAvailableLanguage(language) }}
                              </v-chip>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card-subtitle>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              data-cy="documentDetailsCancelBtn"
              text
              @click="close"
              >{{ $t("builder.documents.details.cancel") }}</v-btn
            >
          </v-card-actions>
        </v-card>
        <delete-dialog
          :dialog="deleteDialog"
          :item="documentName"
          @agree="remove"
          v-show="false"
        />
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import api from "@/utils/api.js";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import { mapGetters, mapState } from "vuex";

export default {
  components: {
    DeleteDialog,
  },
  data: () => ({
    loading: true,
    deleteDialog: false,
    documentName: null,
    document: null,
    languageOptions: [],

    editedItem: {
      uuid: null,
      crm_group: null,
      is_boat_specific: false,
      file_resource: {
        title: null,
        categories: [],
        link: null,
      },
    },
  }),
  created() {
    this.setIntialData();
    api.getDocument(this.$route.params.id).then((resp) => {
      this.editedItem = {
        ...resp.data,
        file_resources: resp.data.file_resources.map((item) => {
          return {
            ...item,
            internalType: item.type !== "link" ? "file" : "link",
          };
        }),
      };
      this.loading = false;
    });
  },
  computed: {
    ...mapGetters(["getIframeStatus"]),
    target() {
      return !this.getIframeStatus ? "_blank" : "";
    },
  },
  methods: {
    setIntialData() {
      this.languageOptions = [
        {
          id: "unknown",
          title: this.$t(
            "components.selectors.multilingualDocumentSelector.unknown"
          ),
        },
        {
          id: "en",
          title: this.$t(
            "components.selectors.multilingualDocumentSelector.english"
          ),
        },
        {
          id: "de",
          title: this.$t(
            "components.selectors.multilingualDocumentSelector.german"
          ),
        },
        {
          id: "fr",
          title: this.$t(
            "components.selectors.multilingualDocumentSelector.french"
          ),
        },
        {
          id: "it",
          title: this.$t(
            "components.selectors.multilingualDocumentSelector.italian"
          ),
        },
        {
          id: "es",
          title: this.$t(
            "components.selectors.multilingualDocumentSelector.spanish"
          ),
        },
      ];
    },
    getAttachmentIcon(type, extension) {
      if (type === "link") {
        return "mdi-link";
      }

      if (
        /(gif|jpe?g|tiff?|png|webp|bmp|svg)$/i.test(extension) &&
        type === "file"
      ) {
        return "mdi-file-image";
      }

      return "mdi-file-document";
    },

    truncateAttachmentName(name) {
      if (name.length > 20) return name.slice(0, 20) + "...";

      return name;
    },
    getAvailableLanguage(language) {
      const languageObject = this.languageOptions.find((item) => {
        return item.id === language;
      });
      if (typeof languageObject === "undefined") return null;
      return languageObject.title;
    },
    close() {
      this.$router.push({
        name: "documents",
      });
    },
    edit() {
      this.$router.push({
        name: "documentsEdit",
        params: { id: this.$route.params.id },
      });
    },
    deleteFn() {
      this.deleteDialog = true;
      this.documentName = this.editedItem.title;
    },

    remove(agreed) {
      if (agreed) {
        api.deleteDocument(this.editedItem.uuid).then((resp) => {
          this.$router.push({
            name: "documents",
          });
        });
      }
      this.deleteDialog = false;
    },
  },
};
</script>
